import { ArrowUpRight, Heart, Star, Truck } from "lucide-react";
import useWatchlist from "@/hooks/useWatchlist";

function ReserveBadge({ lot }) {
  let label;
  let className;
  let testid;
  if (!lot.has_reserve) {
    label = "Nessun prezzo di Riserva";
    className = "bg-black/70 text-white/85";
    testid = "reserve-none";
  } else if (lot.reserve_price_met) {
    label = "Prezzo di Riserva Raggiunto";
    className = "bg-gold/90 text-black";
    testid = "reserve-met";
  } else {
    label = "Prezzo di Riserva non Raggiunto";
    className = "bg-red-900/85 text-white";
    testid = "reserve-not-met";
  }
  return (
    <span
      className={`text-[10px] uppercase tracking-wider px-2 py-1 ${className}`}
      data-testid={`lot-${testid}-${lot.id}`}
    >
      {label}
    </span>
  );
}

function WatchToggle({ lot }) {
  const { isSaved, toggle } = useWatchlist();
  const saved = isSaved(lot.id);
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(lot);
      }}
      className={`flex items-center justify-center w-8 h-8 transition-all ${
        saved
          ? "bg-gold text-black"
          : "bg-black/70 text-white/85 hover:bg-black/85 hover:text-gold"
      }`}
      title={saved ? "Rimuovi da Sotto Osservazione" : "Aggiungi a Sotto Osservazione"}
      aria-label={saved ? "Rimuovi dalla lista Sotto Osservazione" : "Aggiungi alla lista Sotto Osservazione"}
      data-testid={`lot-watch-toggle-${lot.id}`}
      data-watched={saved ? "true" : "false"}
    >
      <Star className={`w-4 h-4 ${saved ? "fill-current" : ""}`} />
    </button>
  );
}

export default function LotCardMedia({ lot }) {
  return (
    <div className="relative overflow-hidden bg-surface aspect-[4/5] mb-5">
      {lot.image_url ? (
        <img
          src={lot.image_url}
          alt={lot.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      ) : (
        <div className="w-full h-full bg-white/5" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      <div className="absolute top-3 left-3 flex flex-col gap-1.5">
        {lot.has_free_shipping && (
          <span className="text-[10px] uppercase tracking-wider bg-black/70 text-white/90 px-2 py-1 flex items-center gap-1">
            <Truck className="w-3 h-3" /> Sped. gratis
          </span>
        )}
        <ReserveBadge lot={lot} />
      </div>

      <div className="absolute top-3 right-3 flex items-center gap-2">
        {lot.favorite_count > 0 && (
          <div className="flex items-center gap-1 bg-black/70 text-white/85 text-[11px] px-2 py-1">
            <Heart className="w-3 h-3" /> {lot.favorite_count}
          </div>
        )}
        <WatchToggle lot={lot} />
      </div>

      <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <div className="bg-white text-black text-[10px] uppercase tracking-[0.2em] px-3 py-2 flex items-center gap-1">
          Vedi su Catawiki <ArrowUpRight className="w-3 h-3" />
        </div>
      </div>
    </div>
  );
}
